import React, { useState, useEffect } from 'react';
import './NavigationBar.css';

const NavigationBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Prevent body scroll when menu is open on mobile
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const handleNavClick = (e, hash) => {
    // Close mobile menu when a link is clicked
    setIsMenuOpen(false);
    e.preventDefault();
    const currentHash = window.location.hash;
    
    if (hash === '#for-astrologers') {
      // Navigate to application page
      if (currentHash !== '#for-astrologers') {
        window.location.hash = '#for-astrologers';
        window.location.reload();
      }
    } else if (hash === '#create-kundali') {
      // Navigate to create kundali page
      if (currentHash !== '#create-kundali') {
        window.location.hash = '#create-kundali';
        window.location.reload();
      }
    } else if (hash === '' || hash === '#home') {
      // Navigate to home page
      if (currentHash === '#for-astrologers' || currentHash === '#create-kundali') {
        window.location.hash = '';
        window.location.reload();
      } else {
        window.location.hash = '#home';
        // Smooth scroll to home section
        const homeElement = document.getElementById('home');
        if (homeElement) {
          homeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    } else {
      // Navigate to section on home page
      if (currentHash === '#for-astrologers' || currentHash === '#create-kundali') {
        // If on application page or create kundali page, store the target hash and go to home
        sessionStorage.setItem('targetHash', hash);
        window.location.hash = '';
        window.location.reload();
      } else {
        // Already on home page, just scroll to section
        window.location.hash = hash;
        const targetElement = document.getElementById(hash.substring(1));
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <a href="#home" onClick={(e) => handleNavClick(e, '')} style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}>
            <img 
              src="/astroindia_white.png" 
              alt="AstroIndia" 
              className="nav-logo-image"
              onError={(e) => {
                // Fallback if image doesn't load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <span className="nav-logo-text" style={{display: 'none'}}>AstroIndia</span>
          </a>
        </div>
        {isMenuOpen && (
          <div 
            className="nav-menu-backdrop" 
            onClick={toggleMenu}
            aria-label="Close menu"
          ></div>
        )}
        <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
          <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>Services</a></li>
          {/* <li><a href="#create-kundali" onClick={(e) => handleNavClick(e, '#create-kundali')}>Create Kundali</a></li> */}
          <li><a href="#for-astrologers" onClick={(e) => handleNavClick(e, '#for-astrologers')}>Astrologer Signup</a></li>
         
          <li>
            <a href="#home" onClick={(e) => handleNavClick(e, '#home')}><button className="nav-cta-button">Get the App</button></a>
          </li>
        </ul>
        <button 
          className={`nav-mobile-toggle ${isMenuOpen ? 'nav-mobile-toggle-active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default NavigationBar;

